import { HttpClient, HttpErrorResponse, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BasketLine } from '../_models/basketline';
import { Order } from '../_models/order';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  baseUrl = environment.apiUrl;
  orders: Order[] = [];
  orderlines: BasketLine[] = [];

  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get<Order[]>(this.baseUrl + 'order').pipe(
      map(orders => {
        return orders;
      })
    );
  }

  getOrderLines(ordernr: String) {
    return this.http.get<BasketLine[]>(this.baseUrl + 'order/' + ordernr).pipe(
      map(orderlines => {
        return orderlines;
      })
    );
  }

}